/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Left_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Top left" |
*
* @param {Position_Top_Left_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_left_aria_label = /** @type {((inputs?: Position_Top_Left_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Left_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En haut a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben links")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вверху слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arriba a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左上")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाएं से बाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto superior esquerdo")
	return /** @type {LocalizedString} */ ("Top left")
});